<doc>
/web/realtime 顶部的大字号单行统计表格
只需要传入 `data` 属性
数据格式为 Array {name, value}
</doc>

<template lang="pug">
.top-statis
    div(v-for="item in data", key="item.name")
        div.ts-name {{item.name}}
        div.ts-value {{item.value | blank}}
</template>

<script>
export default {
    props: {
        data: {
            type: Array,
            required: true
        }
    },
    filters: {
        blank(value) {
            return value == void 0 ? '-' : value;
        }
    }
}
</script>

<style scoped>
.top-statis {
    display: table;
    table-layout: fixed;
    width: 100%;
    background: #fff;
    padding: 20px 0 10px;
    border: 1px solid #e5e5e5;
    border-bottom: 3px solid #e5e5e5;

    & > div {
        display: table-cell;
        text-align: center;
        border-right: 1px solid #e5e5e5;
    }
    & > div:last-child {
        border: 0;
    }
}

.ts-name {
    color: #666;
    font-size: 14px;
}

.ts-value {
    padding: 0 10px;
    font-size: 32px;
    font-weight: bold;
    color: #444;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// top-statis.vue?4a554f8c